import { styled } from 'styled-components';
export const GapWrapper = styled.div `
  display: flex;
  gap: 4px;
  align-items: flex-start;
  flex-direction: ${({ direction }) => direction ?? 'row'};
  flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'nowrap')};
`;
